import ContentDialog from '../../components/Dialogs/ContentDialog'
import { useCurrentTenantRecipient } from '../../core/hooks/useCurrentTenantRecipient'
import { ITenant } from '../../core/types/Tenant'
import { TenantBankAccountWidget } from './TenantBankAccountWidget'
import { getOnboardingMode } from './TenantBankAccountWidget/TenantBankAccountWidget.utils'

type Props = {
  tenant: ITenant | null
}

export default function TenantOnboardingGate({ tenant }: Props) {
  const {
    data: recipientData,
    loading,
    execute,
  } = useCurrentTenantRecipient()

  if (!tenant) return null

  const onboardingMode = getOnboardingMode(recipientData)
  const open =
    !loading && recipientData !== null && onboardingMode !== 'complete'

  return (
    <ContentDialog
      open={open}
      onClose={() => {}}
      hasCancel={false}
      isTitle={false}
      hideButtons
    >
      <TenantBankAccountWidget
        tenantId={tenant.id}
        tenant={tenant}
        recipientData={recipientData}
        reload={execute}
        onClose={() => {}}
        required
      />
    </ContentDialog>
  )
}
